module.exports = __webpack_public_path__ + "img/icon-ticket-win-color.ec582fb4.svg";